import { Klussen } from "@personeel/components/Werklijnen/Personeelsdiensten/Klussen/Klussen.tsx";
import { PersoneelsdienstenModel } from "@personeel/models/PersoneelsdienstenModel.ts";
import { PersoneelsdienstModel } from "@personeel/models/PersoneelsdienstModel.ts";
import { usePersoneelsinstellingenStore } from "@personeel/stores/PersoneelsinstellingenStore.ts";
import { useKlussenStore } from "@personeel/stores/KlussenStore.ts";
import gridStyles from "../../WerklijnenContainer/WerklijnenContainer.module.css";
import { DienstTijden } from "../DienstTijden/DienstTijden";
import styles from "./Personeelsdienst.module.css";
import { calcPosition, calcWidth } from "@personeel/utils/TijdlijnDateCalcUtils";
import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore";

interface IPersoneelsDienst {
  dienst: PersoneelsdienstenModel;
  scale: number;
  expanded: boolean;
}

function maakDienstsleutel(werkperiodeInDienst: PersoneelsdienstModel): string {
  return (
    werkperiodeInDienst.standplaatsDrglptNaam +
    "." +
    werkperiodeInDienst.dienstnummer +
    "." +
    werkperiodeInDienst.starttijd?.toFormat("ccc")
  );
}

export function Personeelsdienst({ dienst, scale }: Readonly<IPersoneelsDienst>) {
  const klussen = useKlussenStore((state) => state.klussen).filter((e) =>
    e.dienst?.includes(dienst.id),
  );

  const timeLineBegin = useSelectedTimeStore((state) => state.scenarioInterval?.start)!;
  const timeLineEnd = useSelectedTimeStore((state) => state.scenarioInterval?.end)!;
  const { voortijd, natijd } = usePersoneelsinstellingenStore((s) => s.personeelsinstellingen);

  return (
    <div className={gridStyles["grid-item"]} id={dienst?.id}>
      <div className={styles["c-duty-task-line"]} data-duty-group-id={dienst.id}>
        {dienst?.personeelsdiensten?.map((werkperiodeInDienst: PersoneelsdienstModel) => {
          const left = calcPosition(
            werkperiodeInDienst.starttijd,
            timeLineBegin,
            timeLineEnd,
            scale,
          );
          const width = calcWidth(
            werkperiodeInDienst.starttijd,
            werkperiodeInDienst.eindtijd,
            timeLineEnd,
            scale,
          );

          // Dropzone beslaat alleen het geldige gedeelte: na voortijd, voor natijd
          const dropZoneBegin = werkperiodeInDienst.starttijd.plus({ minutes: Number(voortijd) });
          const dropZoneEind = werkperiodeInDienst.eindtijd.minus({ minutes: Number(natijd) });
          const dropLeft = calcPosition(dropZoneBegin, timeLineBegin, timeLineEnd, scale);
          const dropWidth = calcWidth(dropZoneBegin, dropZoneEind, timeLineEnd, scale);

          return (
            <div key={maakDienstsleutel(werkperiodeInDienst)}>
              <div
                className={styles["c-duty-drop-zone"]}
                style={{ left: dropLeft, width: dropWidth }}
                data-werkperiode-id={werkperiodeInDienst.id}
              />
              <div
                className={styles["c-duty-active-line"]}
                style={{ left, width }}
                data-active-line-id={werkperiodeInDienst.id}
              />
              <DienstTijden dienst={werkperiodeInDienst} scale={scale} />
            </div>
          );
        })}
        <Klussen klussen={klussen} scale={scale} />
      </div>
    </div>
  );
}
